import { useMapEvents } from 'react-leaflet';
import type { LeafletMouseEvent } from 'leaflet';

export default function MapClickHandler({
  onClick,
  ignoreControls = true,
}: {
  onClick: () => void;
  ignoreControls?: boolean;
}) {
  useMapEvents({
    click: (e: LeafletMouseEvent) => {
      if (ignoreControls) {
        const target = e?.originalEvent?.target as HTMLElement | null;
        if (target?.closest?.('.leaflet-control')) return;
        // Se clicou em um shape (polígono/linha/ponto), não é “fora do mapa”.
        if (target?.closest?.('.leaflet-interactive')) return;
      }
      onClick();
    },
  });

  return null;
}
